import { Component, ElementRef, inject, signal } from '@angular/core';

@Component({
    selector: 'app-select-header',
    templateUrl: './select-header.component.html',
    styleUrls: ['./select-header.component.scss'],
    imports: []
})
export class SelectHeaderComponent {
  el = inject(ElementRef);


  public placeholder = signal<boolean>(false);

  public value = signal<string>(null);

}
